import * as React from 'react';
import { ArvatoForm } from 'components/settings/arvato-form';
import { hasPermissionTo } from 'helpers/permission-helper';
import { Mode } from 'types/mode';
import { Permission } from 'types/permission';
import { SolidsoftForm } from 'components/settings/solidsoft-form';
import { NmvsProvider } from 'types/nmvs-provider';
import { Guid } from 'types/guid';
import { NmvsProviderCredentials } from 'types/tenants/nmvs-provider-credentials';

export interface Props {
  isProcessing: boolean;
  isOnline: boolean;
  permissions: string;
  tenantId: Guid;
  nmvsProvider: NmvsProvider;
  updateNmvsProviderCredentials: Function;
}

export class NmvsProviderCredentialsComponent extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  public render() {
    const canUpdate: boolean = hasPermissionTo([Mode.Update], Permission.TenantProviderCredentials, this.props.permissions);

    switch (this.props.nmvsProvider) {
      case NmvsProvider.Solidsoft:
        return (
          <SolidsoftForm
            isProcessing={this.props.isProcessing}
            isOnline={this.props.isOnline}
            updateNmvsProviderCredentials={this.updateNmvsProvider}
            canUpdate={canUpdate}
          />
        );
      case NmvsProvider.Arvato:
        return (
          <ArvatoForm
            isProcessing={this.props.isProcessing}
            isOnline={this.props.isOnline}
            updateNmvsProviderCredentials={this.updateNmvsProvider}
            canUpdate={canUpdate}
          />
        );
      default:
        return null;
    }
  }

  private updateNmvsProvider = (nmvsProviderCredentials: NmvsProviderCredentials) => {
    this.props.updateNmvsProviderCredentials(this.props.tenantId, nmvsProviderCredentials);
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/nmvs-provider-credentials.tsx